module.exports = __webpack_public_path__ + "img/cases-brand-herborist-lazyload-01.25dd9196.jpg";